<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.prefix') }}*</label>
                <v-select v-model="form.prefix" :clearable="false" :options="prefixOptions" :name="$t('sections.customer.dataForm.prefix')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.name") }}*</label>
                <vs-input type="text" v-model="form.name" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.surname") }}*</label>
                <vs-input type="text" v-model="form.surname" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.idCardNumber')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.idCardNumber") }}*</label>
                <vs-input type="text" v-model="form.idCardNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerNumber')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.lawyerNumber") }}*</label>
                <vs-input type="text" v-model="form.lawyerNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.prosecution.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.location')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.location') }}</label>
                <vs-input type="text" v-model="form.address.location" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumber" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.moo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alley" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.road" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="store" v-model="form.address.subDistrict" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="store" v-model="form.address.district" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="store" v-model="form.address.province" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="store" v-model="form.address.zipcode" label="" class="w-full"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.phone')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.phone') }}</label>
                <vs-input type="text" v-model="form.phone" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.mobile')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.mobile') }}*</label>
                <vs-input type="text" v-model="form.mobile" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.customer.dataForm.email')" rules="email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.email') }}</label>
                <vs-input type="text" v-model="form.email" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.prosecution.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.prosecution.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import {DataStore} from "vue-thailand-address";
import {IStatus} from "@/constants/interface";

const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')
const {mapActions: mapProsecutionActions, mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        idCardNumber: '',
        lawyerNumber: '',
        address: {
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
        },
        phone: '',
        mobile: '',
        email: '',
        status: IStatus.enabled
      },
      store: new DataStore(),
    }
  },
  async created () {
    const vm = this
    const { getPrefixOptions, getLawyers } = vm //,
    await getPrefixOptions()
    await getLawyers()
    this.pms ('ProsecutionLawyer', 'create', 'r')
  },
  computed: {
    ...mapProsecutionFields(['status']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      statusesOptions :'Master/statusesOptions'
    })
  },
  methods: {
    ...mapProsecutionActions(['getLawyers', 'createLawyer']),
    ...mapMasterActions(['getPrefixOptions']),
    async submit () {
      const vm = this
      const { createLawyer } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        createLawyer({
          form: {
            prefix: {id: vm.form.prefix || ''},
            name: vm.form.name,
            surname: vm.form.surname,
            idCardNumber: vm.form.idCardNumber,
            lawyerNumber: vm.form.lawyerNumber,
            address: {
              location: vm.form.address.location,
              houseNumber: vm.form.address.houseNumber,
              moo: vm.form.address.moo,
              alley: vm.form.address.alley,
              road: vm.form.address.road,
              subDistrict: vm.form.address.subDistrict,
              district: vm.form.address.district,
              province: vm.form.address.province,
              zipcode: vm.form.address.zipcode,
            },
            phone: vm.form.phone,
            mobile: vm.form.mobile,
            email: vm.form.email,
            status: vm.form.status.value || vm.form.status
          },
          vm,
          redirect: "/prosecution/lawyer"
        })
      })
    },
    reset () {
      const vm = this;
      const prefixesChoose = vm.prefixOptions.find(res => res.isChoose === true);
      vm.form = {
        prefix: (prefixesChoose ? prefixesChoose.value : ''),
        name: '',
        surname: '',
        idCardNumber: '',
        lawyerNumber: '',
        address: {
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
        },
        phone: '',
        mobile: '',
        email: '',
        status: IStatus.enabled
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
